import React from 'react';
import Lottie from 'lottie-react';
import fireIcon from 'assets/icons/fireButtonIcon.json';
import { Add03 } from 'lib/lucky-x-icons-2';
import AddPrpject from 'components/Project/Add';
import { useToggle } from 'ahooks';
import { useWeb3Modal } from '../Web3Modal';
import { useUserInfo } from 'lib/user';

interface INewRaffleProps {}

const NewProject: React.FC<INewRaffleProps> = (props) => {
  const [open, { toggle, set }] = useToggle(false);
  const { toggleWeb3Modal } = useWeb3Modal();
  const { isLogin } = useUserInfo();

  return (
    <>
      <div
        className="relative flex h-12 cursor-pointer items-center justify-center gap-2 rounded-full border border-divider-dark px-3 text-[#FCFCFD] hover:border-neutral-100 sm:px-6"
        onClick={() => {
          if (!isLogin) {
            toggleWeb3Modal();
          } else {
            set(true);
          }
        }}
      >
        <Add03 className="hidden lg:inline-block" size={24} />
        <div className="text-base font-normal">New Project</div>
        <div className="freeBg absolute -top-3 right-0 flex h-5 items-center justify-center rounded-full px-2 text-xs font-normal text-[#141416]">
          <Lottie animationData={fireIcon} style={{ width: 16 }} />
          FREE
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AddPrpject
            open={open}
            onClose={() => {
              set(false);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default NewProject;
